module.exports = __webpack_public_path__ + "media/images/homes/AddnewcustomersdirectlyfromBOLDPOS-0d11ff10e544ddd3e71e9e230bf94018.png";